import { SponsorsModel } from './../../../../../../libs/shared/src/lib/models/marketplace/sponsors/sponsors.model';
import { ItemFiltersModel } from './../../../../../../libs/shared/src/lib/models/items/item-filters.model';
import { Subject, takeUntil } from 'rxjs';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

import { ErrorService, CategoryService, ItemsService, SellersService } from '@gen/shared';
import { Message } from 'libs/shared/src/lib/utils/message';
import { SellerModel } from 'libs/shared/src/lib/models/sellers/sellers.model';
import { StateManagementService } from 'libs/shared/src/lib/state-management/state-management.service';
import { CategoryModel } from 'libs/shared/src/lib/models/categories/categories.model';
import { ItemsV2Model } from 'libs/shared/src/lib/models/items/V2/ItemV2.model';
import { Router } from '@angular/router';

@Component({
  selector: 'gen-monorepo-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  public loading: boolean = true;
  public filters: ItemFiltersModel = {};
  public sellers: Array<SellerModel> = [];
  public products: Array<ItemsV2Model> = [];
  public categories: Array<CategoryModel> = [];
  public sponsors: Array<SponsorsModel> = [];
  public appDownloadUrl: string = '';

  private destroy$ = new Subject();
  public isMobile: boolean = window.innerWidth < 768;

  constructor(
    private $seller: SellersService,
    private $error: ErrorService,
    private $items: ItemsService,
    private $router: Router,
    private $categories: CategoryService,
    private $notification: StateManagementService
  ) {}

  public ngOnInit(): void {
    this.setTitle();
    this.getItems();
    this.getSponsors();
    this.checkDevice();
    this.getNotification();
  }

  public getNotification(): void {
    this.$notification.categories.subscribe((categories) => {
      if (categories && categories.length > 0) {
        this.treatCategoryList(categories);
      } else {
        this.$categories.getAndSetCategoriesAll();
      }
    });

    this.$notification.sellersList.subscribe((sellers) => {
      if (sellers && sellers.length > 0) {
        this.sellers = sellers;
      } else {
        this.$seller.getSellersMarketplace(this.isMobile);
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(1);
    this.destroy$.complete();
  }

  private setTitle(): void {
    this.$notification.setTitle('');
  }

  private getItems(): void {
    this.$items
      .getV2ItemsSynapses(this.filters)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res?.data?.listV2Items) {
            const data: Array<ItemsV2Model> = JSON.parse(JSON.stringify(res.data.listV2Items));
            this.products = data.splice(0, 5);
          }

          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
          this.$error.errorHandling(error, Message.ERROR_CONECTION, 'ANT');
        },
      });
  }

  public checkDevice(): void {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent)
    ) {
      if (/android/i.test(navigator.userAgent)) {
        this.appDownloadUrl = 'https://play.google.com/store/apps/details?id=br.com.gen&hl=en_AU&gl=US&pli=1';
      }

      if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
        this.appDownloadUrl = 'https://apps.apple.com/br/app/gen-promo%C3%A7%C3%B5es-e-descontos/id6443802221';
      }
    }
  }

  private treatCategoryList(categories): void {
    let options = this.$categories.setCategoriesCascader(categories);

    this.categories = options.map((option) => {
      let nameArray: string[] = option.label.split(' ');
      option.label = nameArray[0].slice(0, 11).replace(',', '');

      return option;
    });
  }

  private getSponsors(): void {
    this.sponsors = [
      {
        imageUrl: '/assets/images/sponsor_nike.svg',
        storeCategoryName: 'Roupas esportiva',
        storeName: 'Nike',
      },
      {
        imageUrl: '/assets/images/sponsor_adidas.svg',
        storeCategoryName: 'Tênis de corrida',
        storeName: 'Adidas',
      },
      {
        imageUrl: '/assets/images/sponsor_iphone.svg',
        storeCategoryName: 'Celulares',
        storeName: 'Iphone',
      },
    ];
  }

  public goToProducts(typeFilter: 'sponsors' | 'category' | 'seller' | 'default', entity?: any): void {
    switch (typeFilter) {
      case 'sponsors':
        // to do
        break;
      case 'category':
        this.$notification.setSeller(null);
        this.$notification.setChangedCategory(entity);
        this.$router.navigate(['/internal/products'], { queryParams: { categoryId: entity.value } });

        break;
      case 'seller':
        this.$notification.setChangedCategory(null);
        this.$notification.setSeller(entity);
        this.$router.navigate(['/internal/products'], { queryParams: { sellerId: entity.id } });
        break;

      case 'default':
        this.$router.navigate(['/internal/products']);
        break;
    }
  }

  public goToProduct(product: ItemsV2Model): void {
    this.$router.navigate(['/internal/products/' + product.id]);
  }

  public goToBrands(): void {
    this.$router.navigate(['/internal/brands/']);
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event: any): void {
    this.isMobile = event.target.innerWidth < 768;
  }
}
